import React from 'react'
import Translation from '../General/Translation'


const MovieMerchandisingItem = ({item, affiliateSlug})  => {
    const { name, urlShop, urlImage, price } = item
    const editedName = name.length > 50 ? name.slice(0, 47).trimEnd() + '...' : name
    const articleUrl = `${urlShop}?partner=${affiliateSlug}`
    const articlePrice = `${price.amount} ${price.currency}`

    return (
        <div className='movie-merchandising-item-container'>
            <div className="movie-merchandising-item theme-radius-posters-full">
                <a href={articleUrl} target="_blank" className="movie-merchandising-link">
                    <img src={urlImage} alt={name} className="movie-merchandising-image"/>
                    <div className='movie-merchandising-info theme-radius-posters-full accent-color-border text-medium'>
                        <span className="movie-merchandising-title text-light">{editedName}</span>
                        <span className="movie-merchandising-price text-light button theme-radius-buttons-full">{articlePrice}</span>
                    </div>
                </a>
            </div>
        </div>
    )
}


const MovieMerchandising = ({ids, data, movieTitle, translation})  => {
    if(
        !data.settings.hasOwnProperty('affiliateSlug') || 
        !data.settings.affiliateSlug ||
        !ids || 
        0 === ids.length
    ) {
        return ''
    } else {
        const items = data.items
        const affiliateSlug = data.settings.affiliateSlug

        return (
            <div className='movie-merchandising-container theme-radius-posters-full'>
                <h3 className='text-large-bold'><Translation id='elbenwaldArticle' trans={translation}>Fanartikel</Translation></h3>
                <h4 className='text-large-medium'><Translation id="elbenwaldArticleTo" trans={translation} after=" ">zu</Translation>{movieTitle}</h4>
                <div className="movie-merchandising theme-radius-posters-full">
                    {ids.map(id => <MovieMerchandisingItem
                        key={id}
                        item={items[id]}
                        affiliateSlug={affiliateSlug}
                    />)}
                </div>
            </div>
        )
    }
}

export default MovieMerchandising

